import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import MainActions from "@/components/MainActions";
import VLFTextField from "@/components/Input/TextField";
import VLFSelectNew from "@/components/Input/SelectNew";
import {FIELD_TYPES, moveField, newFieldId} from "@/utils/scoutingReports";

import "./index.scss";

const TYPE_OPTIONS = FIELD_TYPES.map((t) => ({value: t.id, label: t.label}));

// Modifica di un template di relazione: il blocco giudizio non si tocca, è sempre in fondo.
export default function ReportTemplateEditor({
	template,
	onChange,
	errors = [],
}) {
	const fields = template?.fields || [];
	const setFields = (next) => onChange({...template, fields: next});
	const updateField = (index, changes) =>
		setFields(fields.map((f, i) => (i === index ? {...f, ...changes} : f)));

	return (
		<div className="report-template-editor">
			<div className="rte-name">
				<VLFTextField
					label="Nome del template"
					required
					placeholder="Es. Esterni offensivi"
					value={template?.name || ""}
					onChange={(e) => onChange({...template, name: e.target.value})}
					size="small"
					inputProps={{"aria-label": "Nome del template"}}
					error={errors.includes("name")}
				/>
			</div>

			<ol className="rte-fields">
				{fields.map((field, index) => (
					<li
						key={field.id}
						className={
							"rte-field" + (errors.includes(field.id) ? " has-error" : "")
						}
					>
						<div className="rte-field__row">
							<div>
								<VLFTextField
									label={"Voce " + (index + 1)}
									placeholder="Es. Velocità"
									value={field.label}
									onChange={(e) => updateField(index, {label: e.target.value})}
									size="small"
									inputProps={{"aria-label": "Voce " + (index + 1)}}
									error={errors.includes(field.id) && !field.label?.trim()}
								/>
							</div>
							<div>
								<VLFSelectNew
									label="Tipo"
									aria-label={"Tipo di " + (field.label || "voce")}
									options={TYPE_OPTIONS}
									value={TYPE_OPTIONS.find((o) => o.value === field.type)}
									onChange={(option) =>
										option &&
										updateField(index, {
											type: option.value,
											options:
												option.value === "choice"
													? field.options || []
													: undefined,
											multiple:
												option.value === "choice"
													? !!field.multiple
													: undefined,
										})
									}
									sorted={false}
									isClearable={false}
									noMargin
								/>
							</div>
							<div className="rte-field__actions">
								<IconButton
									size="small"
									aria-label={"Sposta su " + field.label}
									disabled={index === 0}
									onClick={() => setFields(moveField(fields, index, -1))}
								>
									<KeyboardArrowUpIcon fontSize="small" />
								</IconButton>
								<IconButton
									size="small"
									aria-label={"Sposta giù " + field.label}
									disabled={index === fields.length - 1}
									onClick={() => setFields(moveField(fields, index, 1))}
								>
									<KeyboardArrowDownIcon fontSize="small" />
								</IconButton>
								<IconButton
									size="small"
									aria-label={"Elimina " + field.label}
									onClick={() =>
										setFields(fields.filter((_, i) => i !== index))
									}
								>
									<DeleteOutlineIcon fontSize="small" />
								</IconButton>
							</div>
						</div>
						{field.type === "choice" && (
							<VLFTextField
								label="Opzioni, una per riga"
								placeholder={"Es.\nBassa\nMedia\nAlta"}
								value={(field.options || []).join("\n")}
								onChange={(e) =>
									updateField(index, {options: e.target.value.split("\n")})
								}
								multiline
								minRows={3}
								maxRows={10}
								size="small"
								inputProps={{"aria-label": "Opzioni, una per riga"}}
								error={errors.includes(field.id) && !!field.label?.trim()}
								helperText={
									errors.includes(field.id) && field.label?.trim()
										? "Servono almeno due opzioni"
										: ""
								}
							/>
						)}
						<div className="rte-field__flags">
							{field.type === "choice" && (
								<FormControlLabel
									control={
										<Checkbox
											size="small"
											checked={!!field.multiple}
											onChange={(e) =>
												updateField(index, {multiple: e.target.checked})
											}
										/>
									}
									label="Scelta multipla"
								/>
							)}
							<FormControlLabel
								control={
									<Checkbox
										size="small"
										checked={!!field.required}
										onChange={(e) =>
											updateField(index, {required: e.target.checked})
										}
									/>
								}
								label="Obbligatoria"
							/>
						</div>
					</li>
				))}
				<li className="rte-field rte-field--locked">
					<strong>Giudizio finale</strong>
					<span>
						Verdetto (Da prendere, Da seguire, Non idoneo) e giudizio testuale.
						Sempre presente in fondo, obbligatorio.
					</span>
				</li>
			</ol>

			<MainActions
				actions={[
					{
						icon: <AddIcon />,
						label: "Aggiungi voce",
						title: "Aggiungi voce",
						onClick: () =>
							setFields([
								...fields,
								{id: newFieldId(fields), label: "", type: "score"},
							]),
					},
				]}
			/>
		</div>
	);
}
